import React, { useRef, useState } from 'react'
import { toAbsoluteUrl } from '../../../../../_metronic/helpers/AssetHelpers'
import Info from '../../../../../media/shared-access/ic-infoactive.svg'
import { useIntl } from 'react-intl'
import { Tooltip, OverlayTrigger } from 'react-bootstrap'
import Close from '../../../../../media/shared-access/ic-close-2.svg'
import Close2 from '../../../../../media/shared-access/ic-close2.svg'
import { useThemeMode } from '../../../../../_metronic/partials'
import { useAuth } from '../../../auth'

interface InfoCard2Props {
  title: string
  desc: string
  desc2?: string
  slug: string
  className?: string
  toolTipText?: string
}

export const InfoCard2: React.FC<InfoCard2Props> = ({
  title,
  desc,
  desc2,
  slug,
  className,
  toolTipText,
}) => {
  const { formatMessage } = useIntl()
  const { isShowHelpBanners } = useAuth()
  const [isActive, setIsActive] = useState(isShowHelpBanners)
  const triggerRef = useRef<HTMLImageElement>(null)
  const [modalContainer, setModalContainer] = useState<HTMLElement | null>(null)
  const { mode } = useThemeMode()

  const handleIsActive = () => setIsActive(!isActive)

  return (
    <>

      {isActive && (
        <div
          className='info-card important-notice-card rounded mb-4'
          style={
            mode === 'dark' ? {
              backgroundColor: 'rgb(40 40 63)'
            } : { backgroundColor: '#F1FAFF' }
          }
        >
          <div className='p-4 mt-0 fs-6 flex-row position-relative'>
            <div className='d-flex gap-2'>
              {toolTipText ? (
                <div ref={setModalContainer} className='d-inline'>
                  <OverlayTrigger
                    placement='bottom'
                    overlay={
                      <Tooltip id='tooltip'>
                        <p className='m-0'>{formatMessage({ id: toolTipText })}</p>
                      </Tooltip>
                    }
                    container={modalContainer}
                  >
                    <div className='m-0'>
                      <img ref={triggerRef} src={Info} alt='Info' />
                    </div>
                  </OverlayTrigger>
                </div>
              ) : (
                <div className='m-0'>
                  <img src={Info} alt='Info' />
                </div>
              )}

              {/* Title and Desc  */}
              <div className={className ?? 'w-100 mb-6'}>
                <div className='fw-bold mb-1'>{formatMessage({ id: title })}</div>
                <p className='mb-0'>{formatMessage({ id: desc })} </p>
                {desc2 && <p className='mt-4 mb-0'>{formatMessage({ id: desc2 })} </p>}
              </div>
            </div>

            {/* Learn More Link  */}
            <div className='d-flex justify-content-end'>
              <a
                href={slug}
                className='ms-1 link-primary'
                target='_blank'
                rel='noopener noreferrer'
              >
                {formatMessage({ id: 'Learn More' })}
                <span className='ms-5'>
                  <img
                    src={toAbsoluteUrl('/media/icons/duotune/general/arrow-right.svg')}
                    alt='right-arrow'
                  />
                </span>
              </a>
            </div>

            {/* Close Button  */}
            <div className='position-absolute' style={{ top: '8px', right: '8px' }}>
              <button className='btn btn-none p-0 m-0' onClick={handleIsActive}>
                <img src={mode === 'dark' ? Close2 : Close} alt='Close-button' />
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
